export enum Theme {
    NoTheme = 0,
    Fleet = 3,
    TeachingPersonnel = 1,
    ProtocolEducation = 2,
  }